// extracted by mini-css-extract-plugin
export default {"modal":"ModalCita_modal__o7q9R","modal-footer":"ModalCita_modal-footer__nP6mT"};